import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Book = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 25 25"
      fill={fill}
      {...rest}
    >
      <path
        d="M22.9331 17.2399V5.16994C22.9331 3.96994 21.9531 3.07994 20.7631 3.17994H20.7031C18.6031 3.35994 15.4131 4.42994 13.6331 5.54994L13.4631 5.65994C13.1731 5.83994 12.6931 5.83994 12.4031 5.65994L12.1531 5.50994C10.3731 4.39994 7.19311 3.33994 5.09311 3.16994C3.90311 3.06994 2.93311 3.96994 2.93311 5.15994V17.2399C2.93311 18.1999 3.71311 19.0999 4.67311 19.2199L4.96311 19.2599C7.13311 19.5499 10.4831 20.6499 12.4031 21.6999L12.4431 21.7199C12.7131 21.8699 13.1431 21.8699 13.4031 21.7199C15.3231 20.6599 18.6831 19.5499 20.8631 19.2599L21.1931 19.2199C22.1531 19.0999 22.9331 18.1999 22.9331 17.2399Z"
        stroke="#29C452"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M12.9331 5.98999V20.99"
        stroke="#29C452"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M8.68311 8.98999H6.43311"
        stroke="#29C452"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        opacity="0.4"
        d="M9.43311 11.99H6.43311"
        stroke="#29C452"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

Book.displayName = 'Book';
